
  var _styles = {
  "city-explore-progress-v4": {
    "position": "relative",
    "width": "9.57333rem",
    "height": "7.65333rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "city-explore-progress-v4__bg": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.52rem",
    "height": "7.6rem",
    "borderRadius": "0.32rem",
    "zIndex": 0
  },
  "city-explore-progress-v4__content": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "9.57333rem",
    "height": "7.65333rem",
    "zIndex": 2
  },
  "city-explore-progress-v4__header": {
    "position": "absolute",
    "top": "0.32rem",
    "left": "0.32rem",
    "width": "8.93333rem",
    "height": "0.48rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "city-explore-progress-v4__title": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline"
  },
  "city-explore-progress-v4__title-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.4rem",
    "fontWeight": "400",
    "color": "rgb(0,28,55)",
    "lineHeight": "0.48rem"
  },
  "city-explore-progress-v4__title-amount": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.42667rem",
    "fontWeight": "500",
    "color": "rgb(255,45,25)",
    "lineHeight": "0.48rem"
  },
  "city-explore-progress-v4__rule": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "city-explore-progress-v4__rule-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(85,85,85)",
    "marginRight": "0.05333rem"
  },
  "city-explore-progress-v4__rule-arrow": {
    "width": "0.29333rem",
    "height": "0.29333rem"
  },
  "city-explore-progress-v4__panel": {
    "position": "absolute",
    "top": "0.92rem",
    "left": "0.32rem",
    "display": "flex",
    "flexDirection": "column",
    "width": "8.93333rem",
    "height": "3.61333rem",
    "paddingTop": "0.57333rem"
  },
  "city-explore-progress-v4__panel-bg": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "8.93333rem",
    "height": "3.61333rem",
    "zIndex": 0
  },
  "city-explore-progress-v4__hand": {
    "position": "absolute",
    "top": "0.28rem",
    "right": "0.13333rem",
    "width": "1.38667rem",
    "height": "1.38667rem",
    "zIndex": 2
  },
  "city-explore-progress-v4__top-block": {
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "column",
    "paddingLeft": "0.21333rem",
    "marginBottom": "0.37333rem"
  },
  "city-explore-progress-v4__meter-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "marginBottom": "0.2rem"
  },
  "city-explore-progress-v4__meter-num-box": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.8rem",
    "overflow": "visible",
    "marginRight": "0.02667rem"
  },
  "city-explore-progress-v4__meter-num": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.8rem",
    "fontWeight": "700",
    "color": "rgb(17,17,17)"
  },
  "city-explore-progress-v4__meter-unit": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.29333rem",
    "fontWeight": "700",
    "color": "rgb(17,17,17)",
    "marginRight": "0.16rem"
  },
  "city-explore-progress-v4__meter-sub": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)"
  },
  "city-explore-progress-v4__bar": {
    "display": "flex",
    "flexDirection": "row",
    "width": "8.05333rem",
    "height": "0.21333rem",
    "borderRadius": "13.32rem",
    "backgroundColor": "rgb(255,222,228)"
  },
  "city-explore-progress-v4__bar-fill": {
    "height": "0.21333rem",
    "borderRadius": "13.32rem"
  },
  "city-explore-progress-v4__actions": {
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "width": "8.93333rem",
    "height": "1.28rem"
  },
  "city-explore-progress-v4__entry": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.33333rem",
    "height": "1.28rem",
    "borderRadius": "0.16rem",
    "backgroundColor": "rgb(255,229,234)",
    "marginRight": "0.37333rem"
  },
  "city-explore-progress-v4__entry--task": {
    "marginRight": 0
  },
  "city-explore-progress-v4__entry-icon": {
    "width": "0.42667rem",
    "height": "0.42667rem",
    "marginBottom": "0.05333rem"
  },
  "city-explore-progress-v4__entry-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "fontWeight": "500",
    "color": "rgb(17,17,17)"
  },
  "city-explore-progress-v4__cta": {
    "position": "relative",
    "display": "flex",
    "flex": 1,
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "1.28rem",
    "marginRight": "0.37333rem",
    "borderRadius": "13.32rem",
    "overflow": "hidden"
  },
  "city-explore-progress-v4__cta-bg": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0,
    "zIndex": 0
  },
  "city-explore-progress-v4__cta-text": {
    "position": "relative",
    "zIndex": 1,
    "fontFamily": "PingFang SC",
    "fontSize": "0.4rem",
    "fontWeight": "500",
    "color": "rgb(255,255,255)"
  },
  "city-explore-progress-v4__notice": {
    "position": "absolute",
    "top": "4.45333rem",
    "left": "0.02667rem",
    "width": "8.93333rem",
    "height": "0.48rem",
    "overflow": "hidden"
  },
  "city-explore-progress-v4__landmark-section": {
    "position": "absolute",
    "top": "5.14667rem",
    "left": "0.32rem",
    "display": "flex",
    "flexDirection": "column",
    "width": "8.93333rem",
    "height": "2.16rem"
  },
  "city-explore-progress-v4__landmark-header": {
    "width": "8.92rem",
    "height": "0.41333rem",
    "marginBottom": "0.14667rem"
  },
  "city-explore-progress-v4__landmark-row": {
    "display": "flex",
    "flexDirection": "row",
    "width": "8.93333rem",
    "justifyContent": "space-between"
  }
};



  module.exports = _styles;
  